import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { WoAddPaymentComponent } from '../wo-add-payment/wo-add-payment.component';
import { PermissionPipe } from "@shared/pipes/permission";
import { ActionName } from "@shared/enums/action-name";
import { NotificationsService } from "@shared/services/notification";
import { CommonMethods } from "@services/common.method";
import { WorkOrderReviewService } from "@fs/services/work-order-review";

@Component({
  selector: 'wo-total-paid',
  templateUrl: './wo-total-paid.component.html',
  styleUrls: ['./wo-total-paid.component.scss']
})
export class WoTotalPaidComponent implements OnInit {

  //#region Input/Output/ViewChild
  @Input() workTicketPaidDetails: any;
  @Input() workTicketPayment: any;
  @Input() allowAddPayment: boolean = true;
  @Input() subStatus: string;

  @Input() paymentTypes: any;
  @Input() details: any;
  @Input() paymentDisabled: boolean = false;
  @Input() destroyTab: Boolean = false;
  @Input() tabCounter: number;
  @Input() minAmount;
  @Input() alowDeletePayment: boolean;

  @Output() PaymentUpdated = new EventEmitter();
  //@Output() ShowHidParentOverlay = new EventEmitter();

  @ViewChild("woaddPayment") woaddPayment: WoAddPaymentComponent;
  //#endregion

  //#region Variable Declaration
  public hasWOReviewEditPermission: boolean = true;
  public showDeleteConfirmation: boolean = false;
  public showPaymentDelLoader: boolean = false;
  public showPaymentDelOverlay: boolean = false;
  public deleteMessage: string = "";

  private deleteDataItem: any;
 //#endregion

  //#region Constructor
  constructor(
    private permissionPipe: PermissionPipe,
    private toastr: NotificationsService,
    private httpWOReviewService: WorkOrderReviewService
  ) { }
  //#endregion

  //#region Lifecycle Events
  ngOnInit() {
    this.hasWOReviewEditPermission = this.permissionPipe.transform(ActionName.EditWorkOrderReview);
  }
  //#endregion

  //#region Methods
  public PaymentUpdatedFromChild(eventData) {
    this.PaymentUpdated.emit(eventData);
  }

  //public ShHideOverlayFromChild(eventData) {
  //  this.ShowHidParentOverlay.emit(eventData);
  //}

  public DeletePayment(dataItem) {
    this.deleteDataItem = dataItem;
    this.showDeleteConfirmation = true;
    this.showPaymentDelOverlay = true;
    if (
      this.workTicketPaidDetails.data.findIndex(x => x.ID == dataItem.ID) > -1
    ) {
      this.deleteMessage = "This action will permanently delete the record.";
    }
  }
  public ConfirmDelete(ref) {
    this.showDeleteConfirmation = false;
    this.showPaymentDelOverlay = false;
    if (ref) {
      this.showPaymentDelLoader = true;
      this.showPaymentDelOverlay = true;
      let paidDetails = this.details.WorkTicketPayment.WorkTicketPaidDetails;
      this.httpWOReviewService.DeletePayment(this.deleteDataItem).subscribe(
        response => {
          this.showPaymentDelLoader = false;
          this.showPaymentDelOverlay = false;
          this.details.WorkTicketPayment = response;
          paidDetails.splice(
            paidDetails.findIndex(x => x.ID == this.deleteDataItem.ID),
            1
          );
          this.details.WorkTicketPayment.WorkTicketPaidDetails = paidDetails;
          this.PaymentUpdated.emit();
          this.toastr.success("Payment updated successfully");
        },
        error => {
          this.details.WorkTicketPayment.WorkTicketPaidDetails = Object.assign(
            [],
            this.workTicketPaidDetails.data
          );
          this.showPaymentDelLoader = false;
          this.showPaymentDelOverlay = false;
          if (!CommonMethods.CheckNullOrUndefined(error.error))
            this.toastr.showMultiLineError(error.error.Message, "Error");
        }
      );
    } else {
      this.deleteDataItem = null;
    }
  }
  //#endregion
 

}
